import { Button } from "reactstrap";
import { ProductDetails, Symbol } from "../../../../../../constants";
import { ProductDetailsProp } from "../../../../../../types/Ecommerce";

// This component displays product details including category, price, description, and available sizes.
const Details: React.FC<ProductDetailsProp> = ({ singleProduct }) => {
  const productSizeArray: string[] = ["M", "L", "Xl"];

  return (
    <>
      <h3>{singleProduct.category}</h3>
      <div className="product-price fs-4 mb-2">
        {Symbol}
        {singleProduct.price}
        <del className="f-w-700 fs-5 ms-1">
          {Symbol}
          {singleProduct.discountPrice}
        </del>
      </div>
      <div className="product-view">
        <h3>{ProductDetails}</h3>
        <p className="mb-0">{singleProduct.description}</p>
      </div>
      <div className="product-size mt-3 mb-3">
        <ul className="d-flex">
          {/* Mapping through productSizeArray to render the product size options */}
          {productSizeArray.map((items, i) => (
            <li key={i} className="me-2">
              <Button outline color="light">
                {items}
              </Button>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
export default Details;